import Dinero from "dinero.js";

export const formatCurrency = (dollars: number | string) => {
  const numericValue =
    typeof dollars === "string"
      ? parseFloat(dollars.replace(/,/g, ""))
      : dollars;

  if (!Number.isFinite(numericValue)) return "$0.00";

  const cents = Math.round(numericValue * 100);
  const isNegative = cents < 0;
  const formattedAmount = Dinero({
    amount: Math.abs(cents),
    currency: "USD",
  }).toFormat("$0,0.00");

  return isNegative ? `-${formattedAmount}` : formattedAmount;
};

export const formatNumber = (value: number, digits = 2) => {
  return value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  });
};

export const formatPercentage = (value: number): string => {
  return `${Math.round(value)}%`;
};

export const formatPercentWithSignAndPercentage = (value: number): string => {
  return value > 0
    ? `+${formatPercentage(value)}`
    : `${formatPercentage(value)}`;
};
